import { render, staticRenderFns } from "./TabExame.vue?vue&type=template&id=6950bdf6&"
import script from "./TabExame.vue?vue&type=script&lang=js&"
export * from "./TabExame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports